module.exports = __webpack_public_path__ + "img/fossilImg6.d503c80e.jpg";